import base from './base';
import { permissionComputeds, authorOrPermissionMethods } from './base';

export default {
	mixins: [base],
	methods: authorOrPermissionMethods('CHANGE_TASK', 'PUBLISH_TASK', 'ARCHIVE_TASK', 'DELETE_TASK'),
	computed: permissionComputeds('VIEW_TASK', 'ADD_TASK'),
};
